/* istanbul ignore file */
import { datadogRum } from '@datadog/browser-rum';
let initialized = false;
const defaults = {
    ...(typeof window !== 'undefined' ? { allowedTracingUrls: [window.location.origin] } : {}),
    defaultPrivacyLevel: 'mask-user-input',
    sessionReplaySampleRate: 0,
    sessionSampleRate: 100,
    trackFrustrations: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    trackSessionAcrossSubdomains: true,
    useCrossSiteSessionCookie: true,
    useSecureSessionCookie: true
};
/* istanbul ignore next */
export async function initRum(props) {
    if (typeof window !== 'undefined' && !initialized) {
        const config = normalizeRumConfig(props);
        const { applicationId, clientToken } = config;
        if (applicationId && clientToken) {
            datadogRum.init(config);
            if (config.sessionReplaySampleRate && config.sessionReplaySampleRate > 0) {
                datadogRum.startSessionReplayRecording();
            }
        }
        initialized = true;
    }
}
function normalizeRumConfig(props) {
    const config = props;
    /* eslint-disable deprecation/deprecation */
    config.sessionSampleRate = props.sessionSampleRate ?? props.sampleRate ?? defaults.sessionSampleRate;
    delete config.sampleRate;
    config.trackUserInteractions =
        props.trackUserInteractions ?? props.trackInteractions ?? defaults.trackUserInteractions;
    delete config.trackInteractions;
    config.sessionReplaySampleRate =
        props.sessionReplaySampleRate ??
            props.premiumSampleRate ??
            props.replaySampleRate ??
            defaults.sessionReplaySampleRate;
    delete config.premiumSampleRate;
    delete config.replaySampleRate;
    config.allowedTracingUrls = props.allowedTracingUrls ?? props.allowedTracingOrigins ?? defaults.allowedTracingUrls;
    delete config.allowedTracingOrigins;
    config.traceSampleRate = props.traceSampleRate ?? props.tracingSampleRate;
    delete config.tracingSampleRate;
    /* eslint-enable deprecation/deprecation */
    return {
        ...defaults,
        ...config
    };
}
export default initRum;
//# sourceMappingURL=initRum.js.map